import config from '../config';

export async function addOverride(backendFetch, siteId, override) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/overrides/" + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(override)
    })
    if (f.status !== 200) {
        console.error(f)
        throw new Error('Override add failed')
    }
}

export async function getValidOverrides(backendFetch, siteId) {
    const f = await backendFetch(config.REACT_APP_HOST + '/api/v2/overrides/' + siteId, {
        method: "GET",
        headers: {"Content-Type": "application/json"}
    })
    return await f.json()
}

export async function fetchSiteOverridesHistorical(backendFetch, siteId, fromts, tots) {
    fromts = Math.round(fromts.getTime() / 1000);
    tots = Math.round(tots.getTime() / 1000);

    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/overrides/historical/" + siteId + "?fromts=" + fromts + "&tots=" + tots)
    return await response.json();
}


export async function clearOverride(backendFetch, siteId, overrideId) {
    const formData = new FormData()
    formData.append('override_id', overrideId)
    const f = await backendFetch(config.REACT_APP_HOST + '/api/v2/overrides/' + siteId, {
        method: "DELETE",
        body: formData
    })
    return f
}

